import { AppEnvironment } from './environment.model';

/**
 * Ambiente de desenvolvimento — usado por `npm start` e por qualquer build sem
 * `--configuration production`. Aponta para homologação, como esperado.
 */
export const environment: AppEnvironment = {
  production: false,
  defaultTheme: 'light',
  apiBaseUrl: 'https://followee.com.br:3000/v1',
  apiTarget: 'homolog'
};
